<ng-container *ngIf="isVisible">
    <div>
        <div>
            <h3 class="tooltip-text">{{Mensaje}}</h3>
        </div>
    </div>
</ng-container>